module.exports = __webpack_public_path__ + "img/back-nobanner.f69990e8.jpg";